export default __webpack_public_path__ + "media/zurb/img/events/wired/family-giving/family-giving-photos-1f292adec76d9e1f4e3c4112d254545d.png";